import { Navigate, useParams } from "react-router-dom";

export const LegacyRedirect = ({ to }) => <Navigate to={to} replace />;

export const LegacyMerchantProductRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/merchant/products/${slug}`} replace />;
};

export const LegacyAdminMerchantRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/admin/merchants/${id}`} replace />;
};

export const LegacyAdminCustomerRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/admin/customers/${id}`} replace />;
};

export const LegacyStoreProductsRedirect = () => {
  const { merchantId } = useParams();
  return <Navigate to={`/admin/merchants/${merchantId}/products`} replace />;
};

export const MERCHANT_LEGACY_ROUTES = [
  { path: "/MerchantProducts", to: "/merchant/products" },
  { path: "/AddProduct", to: "/merchant/products/new" },
  { path: "/MerchantOrder", to: "/merchant/orders" },
  { path: "/MerchantAccount", to: "/merchant/account" },
  { path: "/MerchantForm", to: "/market/sell" },
];

export const ADMIN_LEGACY_ROUTES = [
  { path: "/markeplaceproductss", to: "/admin/products" },
  { path: "/Marketplacestore", to: "/admin/merchants" },
  { path: "/markplaceadminorder", to: "/admin/orders" },
  { path: "/markeplacecustomer", to: "/admin/customers" },
  { path: "/Marketplacecategory", to: "/admin/categories" },
  { path: "/marketplaceadminbanner", to: "/admin/banners" },
  { path: "/MarketplaceShipping", to: "/admin/shipping" },
  { path: "/markeplaceadminmsg", to: "/admin/messages" },
  { path: "/marketplacesettingss", to: "/admin/settings" },
  { path: "/marketplaceadminpass", to: "/admin/settings" },
];
